var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1 15.7C13.4 15.7 17.4 9.6 17.4 4.4C17.4 4.2 17.4 4.1 17.4 3.9C18.2 3.3 18.9 2.6 19.4 1.8C18.7 2.1 17.9 2.3 17.1 2.4C17.9 1.9 18.5 1.1 18.8 0.2C18 0.7 17.2 1 16.3 1.2C15.6 0.5 14.6 0 13.4 0C11.2 0 9.4 1.8 9.4 4C9.4 4.3 9.4 4.6 9.5 4.9C6.2 4.7 3.3 3.1 1.3 0.7C1 1.3 0.8 2 0.8 2.7C0.8 4.1 1.5 5.3 2.6 6C1.9 6 1.3 5.8 0.8 5.5C0.8 5.5 0.8 5.5 0.8 5.6C0.8 7.5 2.2 9.1 4 9.5C3.7 9.6 3.3 9.6 3 9.6C2.7 9.6 2.5 9.6 2.3 9.5C2.8 11.1 4.3 12.2 6 12.3C4.5 13.4 2.8 14 0.9 14C0.6 14 0.3 14 0 14C1.8 15.1 3.8 15.7 6.1 15.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterImg);
export default __webpack_public_path__ + "static/media/TwitterImg.342fd4d0bf7798a84738dbf4fa844bd5.svg";
export { ForwardRef as ReactComponent };